import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UtilityService } from 'src/app/services/utility.service';
import { UserDocumentService } from '../../services/user-document.service'
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { MapsService } from 'src/app/services/maps.service';
import { AssetService } from 'src/app/services/asset.service';
@Component({
  selector: 'app-incident-reporting-form',
  templateUrl: './incident-reporting-form.component.html',
  styleUrls: ['./incident-reporting-form.component.scss']
})
export class IncidentReportingFormComponent implements OnInit {

  @Input('accident') accidentData
  @Input('user') userData
  @Input('documentData') documentDetails
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  previousIndex: any;
  minTime
  reportingForm1: FormGroup
  reportingForm2: FormGroup
  reportingForm3: FormGroup
  reportingForm4: FormGroup
  dateIsValid
  sign: boolean;
  isSubmit: boolean;
  isSubmit1: boolean
  dateisValid: boolean
  date
  eventdate
  chosenTime1
  chosenTime2
  reportingDate
  anticipateDate
  loading: boolean;
  accidentId: any;
  userId: any;
  accidentDetails: any;
  userDetails: any;
  formDetails: any;
  form2Details: any;
  form3Details: any;
  form4Details: any;
  extraDetails: any;
  isEdit: boolean;
  userName: any;
  accidentLocation: any;
  dateOfIncident: any;
  files: any = [];
  newFiles: any = [];
  currentUser
  latitude: number;
  longitude: number;
  latitude2: number;
  longitude2: number;
  zoom: number;
  address: string;
  address2: string;
  map: google.maps.Map;
  bounds
  geoCoder
  user: any;
  isAdmin: boolean;
  latitude3: any;
  longitude3: any;
  address3: any;
  isMapEdit: boolean

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private formBuilder: FormBuilder,
    public _utilityService: UtilityService,
    public userDocumentService: UserDocumentService,
    public _assetService: AssetService,
    private _mapsService: MapsService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.isSubmit = false
    this.isSubmit1 = false
    this.loading = false;
    this.user = JSON.parse(localStorage.getItem('userRoles'));
    console.log("this.user", this.user);
    if (this.user.isAdmin) {
      console.log("this.isAdmin", this.user.isAdmin);
      this.isAdmin = true
    }
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    // this.setCurrentLocation();
    this.createForm1()
    this.createForm2()
    this.createForm3()
    this.createForm4()
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES in child component", changes);
    if (changes.accidentData && changes.accidentData.currentValue) {
      this.accidentId = changes.accidentData.currentValue
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
    }
    if (changes.documentDetails && changes.documentDetails.currentValue) {
      let data = changes.documentDetails.currentValue
      this.accidentDetails = data.accidentDetails
      this.userDetails = data.userData

      if (data && data.details && data.details && data.details.details.reportingForm1) {
        this.formDetails = data.details.details.reportingForm1
        this.form2Details = data.details.details.reportingForm2
        this.form3Details = data.details.details.reportingForm3
        this.form4Details = data.details.details.reportingForm4
        this.extraDetails = data.details
        this.files = data.details.files
        console.log("data.details--->", data.details);

        this.latitude3 = (data.details.details.reportingForm1 && data.details.details.reportingForm1.location) ? data.details.details.reportingForm1.location.coords.lat : ''
        this.longitude3 = (data.details.details.reportingForm1 && data.details.details.reportingForm1.location) ? data.details.details.reportingForm1.location.coords.lng : ''
        this.address3 = (data.details.details.reportingForm1 && data.details.details.reportingForm1.location) ? data.details.details.reportingForm1.location.address : ''
        this.reportingForm1.value['location'] = {
          coords: { lat: this.latitude3, lng: this.longitude3 },
          address: this.address3
        }

        this.latitude = (data.details.details.reportingForm2 && data.details.details.reportingForm2.eventLocation) ? data.details.details.reportingForm2.eventLocation.coords.lat : ''
        this.longitude = (data.details.details.reportingForm2 && data.details.details.reportingForm2.eventLocation) ? data.details.details.reportingForm2.eventLocation.coords.lng : ''
        this.address = (data.details.details.reportingForm2 && data.details.details.reportingForm2.eventLocation) ? data.details.details.reportingForm2.eventLocation.address : ''
        this.reportingForm2.value['eventLocation'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }

        this.latitude2 = (data.details.details.reportingForm3 && data.details.details.reportingForm3.witnessLocation) ? data.details.details.reportingForm3.witnessLocation.coords.lat : ''
        this.longitude2 = (data.details.details.reportingForm3 && data.details.details.reportingForm3.witnessLocation) ? data.details.details.reportingForm3.witnessLocation.coords.lng : ''
        this.address2 = (data.details.details.reportingForm3 && data.details.details.reportingForm3.witnessLocation) ? data.details.details.reportingForm3.witnessLocation.address : ''
        this.reportingForm3.value['witnessLocation'] = {
          coords: { lat: this.latitude2, lng: this.longitude2 },
          address: this.address2
        }

        // this.chosenTime = this.formDetails.time
        // this.date = this.formDetails.date
        this.isEdit = true
        this.isMapEdit = true
        if (this.form4Details && this.form4Details.sign != "") {
          this.sign = true
        }
        this.createForm1(this.formDetails)
        this.createForm2(this.form2Details)
        this.createForm3(this.form3Details)
        this.createForm4(this.form4Details)
      } else {



        this.isEdit = false
        this.isMapEdit = false
        // this.userName = this.userDetails && this.userDetails._id ? this.userDetails._id.user.name : this.userDetails.user.name
        this.accidentLocation = this.accidentDetails && this.accidentDetails.location && this.accidentDetails.location.address ? this.accidentDetails.location.address : ''
        this.dateOfIncident = this.accidentDetails.date
        if (this.userDetails && this.userDetails._id && this.userDetails._id.user) {
          console.log("this user details", this.userDetails);

          this.userName = this.userDetails._id.user.name
        } else {
          this.userName = this.userDetails.user.name
        }
        this.createForm1()
        this.createForm2()
        this.createForm3()
        this.createForm4()
        console.log("call this else part", this.userName, this.accidentLocation);
      }
    }


  }



  // FORM GROUP
  createForm1(data?) {
    this.reportingForm1 = this.formBuilder.group({
      fullname: new FormControl((data && data.fullname) ? data.fullname : this.userName),
      // forename: new FormControl((data && data.forename) ? data.forename : ''),
      // location: new FormControl((data && data.location) ? data.location : this.accidentLocation),
      role: new FormControl((data && data.role) ? data.role : '')
    })
  }

  createForm2(data?) {
    this.reportingForm2 = this.formBuilder.group({
      eventdate: new FormControl((data && data.eventdate) ? data.eventdate : this.dateOfIncident),
      timePick1: new FormControl((data && data.timePick1) ? data.timePick1 : ''),
      // eventLocation: new FormControl((data && data.eventLocation) ? data.eventLocation : ''),
      bodyInjury: new FormControl((data && data.bodyInjury) ? data.bodyInjury : ''),
      injuryNature: new FormControl((data && data.injuryNature) ? data.injuryNature : ''),
      whatHappen: new FormControl((data && data.whatHappen) ? data.whatHappen : ''),
      vehicleRegNo: new FormControl((data && data.vehicleRegNo) ? data.vehicleRegNo : ''),
      vehicleModel: new FormControl((data && data.vehicleModel) ? data.vehicleModel : '')
    })
  }

  createForm3(data?) {
    this.reportingForm3 = this.formBuilder.group({
      aidGiven: new FormControl((data && data.aidGiven) ? data.aidGiven : ''),
      byWhom: new FormControl((data && data.byWhom) ? data.byWhom : ''),
      hospitalTaken: new FormControl((data && data.hospitalTaken) ? data.hospitalTaken : ''),
      whichHospital: new FormControl((data && data.whichHospital) ? data.whichHospital : ''),
      stayOvernight: new FormControl((data && data.stayOvernight) ? data.stayOvernight : ''),
      offWork: new FormControl((data && data.offWork) ? data.offWork : ''),
      workExpected: new FormControl((data && data.workExpected) ? data.workExpected : ''),
      anticipateDate: new FormControl((data && data.anticipateDate) ? data.anticipateDate : ''),
      anyWitness: new FormControl((data && data.anyWitness) ? data.anyWitness : ''),
      nameWitness: new FormControl((data && data.nameWitness) ? data.nameWitness : '')
    })
  }

  createForm4(data?) {
    this.reportingForm4 = this.formBuilder.group({
      whomReport: new FormControl((data && data.whomReport) ? data.whomReport : ''),
      timePick2: new FormControl((data && data.timePick2) ? data.timePick2 : ''),
      reportingDate: new FormControl((data && data.reportingDate) ? data.reportingDate : ''),
      sign: new FormControl((data && data.sign) ? data.sign : '', Validators.required),
      date: new FormControl((data && data.date) ? data.date : '', Validators.required)
    })
  }

  // UTILITY

  onChangeEvent(value, formControl) {
    if (formControl == 'eventdate')
      this.reportingForm2.patchValue({ eventdate: value })
    else if (formControl == 'anticipateDate')
      this.reportingForm3.patchValue({ anticipateDate: value })
    else if (formControl == 'date') {
      this.reportingForm4.patchValue({ date: value })
      this.dateisValid = true;
      this.isSubmit1 = false;
    }
    else
      this.reportingForm4.patchValue({ reportingDate: value })
  }



  setCurrentLocation3(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude3 = mapCurrentValue.latitude
    this.longitude3 = mapCurrentValue.longitude
    this.address3 = mapCurrentValue.address
  }

  setCurrentLocation2(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude2 = mapCurrentValue.latitude
    this.longitude2 = mapCurrentValue.longitude
    this.address2 = mapCurrentValue.address
  }

  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address

  }
  // markerDragEnd3(event) {
  //   console.log('mark drag event check', event);
  //   this._mapsService.markerDragEnd(event).subscribe((data) => {
  //     console.log("data------->", data);
  //     this.latitude3 = data.latitude;
  //     this.longitude3 = data.longitude;
  //     this.address3 = data.address;
  //   });
  // }

  // markerDragEnd2(event) {
  //   console.log('mark drag event check', event);
  //   this._mapsService.markerDragEnd(event).subscribe((data) => {
  //     console.log("data------->", data);
  //     this.latitude2 = data.latitude;
  //     this.longitude2 = data.longitude;
  //     this.address2 = data.address;
  //   });
  // }



  // markerDragEnd(event) {
  //   console.log('mark drag event check', event);
  //   this._mapsService.markerDragEnd(event).subscribe((data) => {
  //     console.log("data------->", data);
  //     this.latitude = data.latitude;
  //     this.longitude = data.longitude;
  //     this.address = data.address;
  //   });
  // }

  timePick1Changed(value) {
    this.reportingForm2.patchValue({ timePick1: value })
    // console.log("clock time: 1", value);
  }
  timePick2Changed(value) {
    this.reportingForm4.patchValue({ timePick2: value })
    // console.log("clock time: 2", value);
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }

  addSignature(fomrControl) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
      null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
        console.log("data of sign", data);
        this.sign = true
        this.isSubmit = false
        if (fomrControl == 'sign') {
          this.reportingForm4.patchValue({
            sign: data
          })
          console.log("sign value", this.reportingForm4.value);
        }
      })
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }


  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }


  // API CALL

  onSubmit() {
    let param = {
    }
    if (this.reportingForm1.valid && this.reportingForm2.valid && this.reportingForm3.valid && this.reportingForm4.valid) {
      this.loading = true;
      console.log("form-1 value", this.reportingForm1.value)
      console.log("form-2 value", this.reportingForm2.value)
      console.log("form-3 value", this.reportingForm3.value)
      console.log("form-4 value", this.reportingForm4.value)
      // this.loading = false;



      if (this.isEdit) {

        console.log("this is for edit form");


        let obj = {
          metaObj: {
            title: 'irForm',
          },
          documentId: this.accidentId,
          userId: this.userId,
          onModel: 'accident',
          documentMetaId: this.extraDetails.documentMetaId,
          userDocumentId: this.extraDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }
        this.reportingForm1.value['location'] = {
          coords: { lat: this.latitude3, lng: this.longitude3 },
          address: this.address3
        }
        this.reportingForm2.value['eventLocation'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        this.reportingForm3.value['witnessLocation'] = {
          coords: { lat: this.latitude2, lng: this.longitude2 },
          address: this.address2
        }

        let details = {
          reportingForm1: this.reportingForm1.value,
          reportingForm2: this.reportingForm2.value,
          reportingForm3: this.reportingForm3.value,
          reportingForm4: this.reportingForm4.value
        }
        obj['details'] = details
        this.userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
          this.loading = false
        })


      } else {
        let obj = {
          metaObj: {
            title: 'irForm',
          },
          documentId: this.accidentId,
          userId: this.userId,
          onModel: 'accident',
          files: this.files,
          // documentId: this.planFormDetails._id,
          details: {}
        }
        this.reportingForm1.value['location'] = {
          coords: { lat: this.latitude3, lng: this.longitude3 },
          address: this.address3
        }
        this.reportingForm2.value['eventLocation'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        this.reportingForm3.value['witnessLocation'] = {
          coords: { lat: this.latitude2, lng: this.longitude2 },
          address: this.address2
        }

        let details = {
          reportingForm1: this.reportingForm1.value,
          reportingForm2: this.reportingForm2.value,
          reportingForm3: this.reportingForm3.value,
          reportingForm4: this.reportingForm4.value
        }

        obj['details'] = details

        this.userDocumentService.addUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          // this._utilityService.handleSnackBar({ msg: "Witness form Submision successfully!", button: "OK" })
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
          this.loading = false
        })
      }
    }
    else {
      this.loading = false;
      this.isSubmit = true
      this.isSubmit1 = true
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    let param = {
    }
    param['accidentId'] = this.accidentId
    if (this.isAdmin) {
      this.router.navigate(['/accident/single-accident'], { queryParams: param })
    }
    else {
      this.router.navigate(['/accident'])
    }
  }


}
